import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { BackIcon, HomeIcon } from '@triplabo/web/assets';
import { LanguageSelector } from '@triplabo/web/components';
import { isWeb, canGoBack } from '@triplabo/web/utils';
import styles from './back.module.css';

interface BackProps {
  onBack?: () => void;
  title?: string;
  top?: number;
  left?: number;
  inline?: boolean;
  justIcon?: boolean;
  showHome?: boolean;
  showLanguage?: boolean;
}

const Back: FC<BackProps> = ({
  onBack,
  title,
  top = 12,
  left = 12,
  inline = false,
  justIcon = false,
  showHome = true,
  showLanguage = true
}) => {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    if (onBack) {
      onBack();
      return;
    } else if (canGoBack()) {
      navigate(-1);
    } else {
      navigate('/home', { replace: true });
    }
  }, [onBack, navigate]);

  const handleHome = useCallback(() => {
    navigate('/home');
  }, [navigate]);

  if (justIcon) {
    return (
      <button className={styles.justIconButton} onClick={handleBack}>
        <BackIcon className={styles.justIcon} />
      </button>
    );
  }

  if (inline) {
    return (
      <div className={styles.headerWrapper}>
        <div className={styles.inlineBack}>
          <button className={styles.inlineBackButton} onClick={handleBack}>
            <BackIcon className={styles.inlineBackIcon} />
          </button>
          {title && <span className={styles.title}>{title}</span>}
          {isWeb && showLanguage && (
            <div className={styles.languageContainer}>
              <LanguageSelector />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles.backWrapper}
      style={{ top: `${top}px`, left: `${left}px` }}
    >
      <button className={styles.back}>
        <BackIcon className={styles.backIcon} onClick={handleBack} />
      </button>
      <button className={styles.home} onClick={handleHome}>
        {showHome && (
          <HomeIcon className={styles.homeIcon} onClick={handleHome} />
        )}
      </button>
    </div>
  );
};

export default Back;
